var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Accordion from "../Accordion";
import "../../styles/ChooseTheImage.css";
import ImageIcon from '@mui/icons-material/Image';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
;
var orientationClass = function (orientation) {
    return orientation ? "image-preview--".concat(orientation.toLowerCase()) : '';
};
function ChooseTheImageStep(_a) {
    var imageId = _a.imageId, onChange = _a.onChange, images = _a.images, products = _a.products, onNext = _a.onNext, isOpen = _a.isOpen, onToggle = _a.onToggle, isValid = _a.isValid;
    var _b = useState([]), openProductIds = _b[0], setOpenProductIds = _b[1];
    var _c = useState(new Set()), erroredImages = _c[0], setErroredImages = _c[1];
    var groupedImages = images.reduce(function (acc, img) {
        var productKey = img.category === 'generic' ? 'noProduct' : String(img.productId);
        if (!acc[productKey])
            acc[productKey] = [];
        acc[productKey].push(img);
        return acc;
    }, {});
    var storageUrl = process.env.REACT_APP_STORAGE_URL;
    if (!groupedImages['noProduct']) {
        groupedImages['noProduct'] = [];
    }
    function getProductName(productId) {
        if (productId === 'noProduct')
            return 'Imagens Genéricas';
        var product = products.find(function (p) { return String(p.id) === productId; });
        return product ? product.name : productId;
    }
    ;
    function handleProductToggle(productId) {
        setOpenProductIds(function (prev) {
            return prev.includes(productId)
                ? prev.filter(function (id) { return id !== productId; })
                : __spreadArray(__spreadArray([], prev, true), [productId], false);
        });
    }
    ;
    function handleImageError(id) {
        setErroredImages(function (prev) { return new Set(prev).add(id); });
    }
    ;
    var isNextDisabled = !imageId;
    return (_jsxs(Accordion, __assign({ title: "Escolha a imagem", name: "imageId", step: 5, isOpen: isOpen, onToggle: onToggle, isValid: isValid }, { children: [_jsx("div", __assign({ className: "image-selector" }, { children: Object.entries(groupedImages).map(function (_a, index, array) {
                    var productId = _a[0], imgs = _a[1];
                    return (_jsxs("div", __assign({ className: "product-group" }, { children: [_jsxs("button", __assign({ type: "button", className: "product-header", onClick: function () { return handleProductToggle(productId); } }, { children: [_jsx("span", { children: getProductName(productId) }), openProductIds.includes(productId) ? (_jsx(KeyboardArrowUpOutlinedIcon, {})) : (_jsx(KeyboardArrowDownOutlinedIcon, {}))] })), openProductIds.includes(productId) && (_jsx("div", __assign({ className: "image-grid" }, { children: imgs.length > 0 ? (imgs.map(function (img) { return (_jsx("button", __assign({ type: "button", className: "image-preview preview-image-product ".concat(orientationClass(img.orientation), " ").concat(imageId === img.id ? 'selected' : ''), onClick: function () {
                                        if (imageId === img.id) {
                                            onChange('');
                                        }
                                        else {
                                            onChange(img.id);
                                        }
                                    } }, { children: !erroredImages.has(img.id) ? (_jsx("img", { src: "".concat(storageUrl, "/").concat(img.path), alt: "preview", onError: function () { return handleImageError(img.id); } })) : (_jsx("div", __assign({ className: "preview-image-product rrrrr" }, { children: _jsx(ImageIcon, {}) }))) }), img.id)); })) : (_jsx("div", __assign({ className: "preview-image-product kue" }, { children: _jsx(ImageIcon, {}) }))) }))), array.length > 1 && index < array.length - 1 && _jsx("hr", {})] }), productId));
                }) })), _jsx("div", __assign({ className: "step-footer" }, { children: _jsx("button", __assign({ type: "button", className: "continue-button button-with-blue-border", onClick: onNext, disabled: isNextDisabled }, { children: "Continuar" })) }))] })));
}
export default ChooseTheImageStep;
